
import { Component, Vue } from 'nuxt-property-decorator';
import CloseBtn from './CloseBtn.vue';
import PollyVoiceSelect from '@/components/ui/read-aloud/library/PollyVoiceSelect.vue';
import PollyReadingSpeed from '@/components/ui/read-aloud/library/PollyReadingSpeed.vue';
import ReadAloudStore from '@/components/ui/read-aloud/library/read-aloud.store';
import SidePanelStore from '@/components/ui/side-panel/side-panel.store';

@Component({
  components: { CloseBtn, PollyReadingSpeed, PollyVoiceSelect }
})
export default class ReadabilitySettings extends Vue {
  get isStateDifferentFromDefault(): boolean {
    return ReadAloudStore.isStateDifferentFromDefault;
  }

  closeSidePanel(): void {
    SidePanelStore.rightPanelIsOpen = false;
  }

  resetReadAloudSettings(): void {
    ReadAloudStore.resetReadAloudSettings();
    ReadAloudStore.settingsChanged = true;
  }
}
